export const getFieldIcon = (type) => {
  const iconMap = {
    textfield: "text_fields",
    textarea: "article",
    richtext: "text_format",
    number: "123",
    phone: "call",
    password: "password",
    email: "mail",
    checkbox: "check_box",
    toggle: "toggle_on",
    file: "file_copy",
    url: "link",
    radio: "radio_button_checked",
    currency: "payments",
    button: "touch_app",
    select: "done_all",
    selectbox: "checklist",
    selectboxes: "checklist",
    "multi-select-dropdown": "keyboard_arrow_down",
    date: "event",
    "date-range": "date_range",
    "multi-date": "calendar_month",
    day: "today",
    datetime: "work_history",
    disabled: "visibility_off",
    content: "code",
    geolocation: "pin_drop",
    container: "list_alt",
    entity: "stars",
    lookup: "visibility",
    "lookup-sm": "eye_tracking",
    "linked-sm-lookup": "mystery",
    "lookup-rdbms": "database_search",
    "masterdata-lookup": "manage_search",
    "app-user": "person",
    // "community-user": "group",
    recordset: "table",
    "recordset-list": "table_view",
    "button-group": "ad_group",
    time: "schedule",
    image: "image",
    "learning-text": "dictionary",
    "learning-tags": "book",
    "global-data": "globe",
    "id-gen": "rule_settings",
    ratings: "star",
    statemachine: "flowchart",
    rdbms: "table",
    postgres: "database",
    workflow: "rebase",
    appuser: "person",
    // communityuser: "group",
    activity: "activity_zone",
    RvTemplate: "table_eye",
    label: "label",
    "select-chips": "check_circle",
    percentage: "percent",
    video: "ondemand_video",
    audio: "mic",
    signature: "signature",
    counter: "contrast_square",
    grid: "view_compact",
    slider: "tune",
    spacer: "space_bar",
    json: "data_object",
    dropdown: "keyboard_arrow_down",
    "dropdown-navigate": "keyboard_arrow_down",
    form: "list_alt",
    mail_thread: "mail",
    tableview: "table_view",
    table: "table_view",
    timeline: "view_timeline",
    file_viewer: "file_copy",
    file_preview: "file_open",
    html: "html",
    "dynamic-html": "code_blocks",
    separator: "horizontal_rule",
    tabview: "tabs",
    section: "check_box_outline_blank",
    full: "check_box_outline_blank",
    column: "view_week",
    block: "tile_medium",
    "rich-grid": "view_agenda",
    "progress-tracker": "progress_activity",
    "number-select": "format_list_numbered",
    "": "dns",
    int: "pin",
    instance_id: "id_card",
    pk: "key",
    varchar: "ABC",
    fk: "lan",
    empty: "variable_add",
    activitycard: "browse_activity",
    "activity-recordsview": "browse_activity",
    recordsview: "table_chart",
    chart: "insert_chart",
    "progress-bar": "progress_activity",
    icon: "emoji_symbols",
    field: "input",
    rv_table: "table_chart",
    map: "map",
    rv_tile: "view_module",
    rv_chart: "pie_chart",
    rv_filters: "tune",
    search_box: "search",
    rv_columns_manager: "view_column",
    download_file: "download",
    rv_action_button: "touch_app",
    rv_action_dropdown: "arrow_drop_down_circle",
    rv_table_catalog_toggler: "flip_camera_android",
    rv_actions_list: "list",
    rv_tab_filters: "filter_alt",
    tab: "tab",
    ocr: "document_scanner",
    "ai-doc-analyzer": "analytics",
    "dv-group": "clarify",
    "custom-component": "code",
    json_to_table: "grid_on",
    "document-ocr": "text_snippet"
  };

  return iconMap[type] || "";
};
